import { WSAlert } from "@wingspanhq/fe-component-library";
import { useQueryPendingPayrollInvoices } from "./queries/useQueryPendingPayrollInvoices";

export const AlertPayrollRunInProgress: React.FC = () => {
  const queryPendingPayrollInvoices = useQueryPendingPayrollInvoices();

  const pendingPayrollInvoices = queryPendingPayrollInvoices.data || [];

  if (pendingPayrollInvoices.length === 0) {
    return null;
  }

  return (
    <WSAlert theme="info" title="A payroll run is already in progress">
      A payroll run is already in progress (scheduled or off-cycle). Once the
      progress is complete, a new off-cycle payroll run can be initiated.
    </WSAlert>
  );
};
